// @ts-nocheck
import { TECNotificationModel } from "@store/Framework/Types/ApiModels";
import {
    sendTECNotificationEmail,
    TECNotificationApiParameter,
} from "@store/Framework/Services/TaxExemptionCertificatesService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type SubmitTECNotificationParameter = {
    tecNotificationModel: TECNotificationModel;
    onSuccess?: () => void;
    onError?: () => void;
} & HasOnSuccess &
    HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<SubmitTECNotificationParameter, TECNotificationApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    await sendTECNotificationEmail(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitTECNotificationForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitTECNotificationForm;
